<template>
  <div class="navbar__wrapper">
    <nav class="navbar">
      <router-link to="/" class="navbar-brand [ mr-3 ]">
        <img class="navbar-brand__logo" src="../assets/logo.svg" alt="">
      </router-link>
      <button class="navbar-toggler navbar-toggler--search collapsed [ ml-auto mr-3 ]" type="button" data-toggle="collapse" data-target="#navbar-search">
        <img class="navbar-toggler__icon" src="../assets/ico-search.svg">
      </button>
      <button class="navbar-toggler navbar-toggler--main collapsed" type="button" data-toggle="collapse" data-target="#navbar-main">
        <span class="navbar-toggler__icon">
          <span class="navbar-toggler__line navbar-toggler__line--top"></span>
          <span class="navbar-toggler__line navbar-toggler__line--middle"></span>
          <span class="navbar-toggler__line navbar-toggler__line--bottom"></span>
        </span>
      </button>

      <div class="nav [ collapse navbar-collapse ]" id="navbar-main">
        <div class="navbar-nav navbar-nav--main [ justify-content-center align-items-center ]">
          <div class="text-center [ border-bottom ] [ w-100 ] [ p-4 ]">
            <router-link to="/" @click.native="collapseMenuMain()"><img src="../assets/logo-alt.svg" class="nav__logo" alt=""></router-link>
          </div>
          <div class="text-center">
            <span class="nav__title [ pt-4 ]">Categorie eventi</span>
            <ul class="list-unstyled">
              <router-link v-for="(tag,i) in tags" :key="i" :to="'/eventi/'+tag.Codice" tag="li" class="nav-item" @click.native="collapseMenuMain()">
                <a class="nav-link nav-link--button">
                  {{tag.Descrizione}}
                  <app-category :color="tag.Colore"></app-category>
                  <!--<span class="ico-cat" :class="'ico-cat--'+tag.Codice"></span>-->
                </a>
              </router-link>
            </ul>
          </div>
          <div class="text-center [ border-top ] [ w-100 ] [ p-4 ]">
            <router-link to="/eventi/all" @click.native="collapseMenuMain()" class="nav__link [ py-2 ]">Calendario eventi</router-link>
            <router-link to="/info" @click.native="collapseMenuMain()" class="nav__link [ py-2 ]"><img src="../assets/ico-mail.svg" alt=""> Info</router-link>
          </div>
        </div>
      </div>

    </nav>

    <div class="nav [ collapse navbar-collapse ]" id="navbar-search">
      <div class="navbar-nav navbar-nav--search">
        <div class="form-group">
          <input type="text" v-model="search" placeholder="cerca evento" class="form-control" />
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <input type="date" v-model="start"  placeholder="DA: GG/MM/AAAA" class="form-control" />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <input type="date" v-model="end"  placeholder="A: GG/MM/AAAA" class="form-control" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 [ mt-auto ]">
            <button type="button" class="btn btn-none" @click="collapseMenuSearch()"><img src="../assets/ico-close.svg" alt=""></button>
          </div>
          <div class="col-6 [ text-right ]">
            <button type="button" class="btn btn-secondary" @click="ricerca">Cerca</button>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar__before [ d-lg-none ]">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 1080">
        <path d="M-1,1 L-1,1 L210,14 L421,1 L421,-1 L-1,-1 Z" style="fill:#ffffff;stroke:#d57b13;stroke-linejoin:round;stroke-width:1px" />
      </svg>
    </div>
    <div class="navbar__after">
      <svg xmlns="http://www.w3.org/2000/svg" class="dark" viewBox="0 0 420 1080"><path d="M0,0 L0,0 L421,0 L421,0 L0,0 Z" style="fill:#2E2C2B;" /></svg>
      <svg xmlns="http://www.w3.org/2000/svg" class="secondary" viewBox="0 0 420 1080"><path d="M0,0 L0,0 L421,0 L421,0 L0,0 Z" style="fill:#ffb259;" /></svg>
      <svg xmlns="http://www.w3.org/2000/svg" class="primary" viewBox="0 0 420 1080"><path d="M0,0 L0,0 L421,0 L421,0 L0,0 Z" style="fill:#D57B13;" /></svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppNavbar',
  data () {
    return {
      search: '',
      start: null,
      end: null
    }
  },
  computed: {
    tags () {
      if (this.$store.state.event.tags.length > 0 && $('#stilitags').length == 0) {
        var style = '<style type="text/css" id="stilitags">'
        for (var i = 0; i < this.$store.state.event.tags.length; i++) {
          var t = this.$store.state.event.tags[i]
          style += '.text-' + t.Codice + '{ color:' + t.Colore + '!important; }'
          style += '.background-cat--' + t.Codice + ' { background-image: url(img/categories/' + t.Codice + '.jpg?rnd=' + Math.random() + ') !important;}'
        }
        style += '</style>'
        $('head').append(style)
      }
      return this.$store.state.event.tags
    },
    inViewport () {
      for (let key in this.scrollState) {
        if (this.scrollState[key].isInViewport || this.scrollState[key].isFullyInViewport) {
          return true
        }
        return false
      }
    }
  },
  methods: {
    collapseMenuMain () {
      $('.navbar-toggler--main').trigger('click')
    },
    collapseMenuSearch () {
      $('.navbar-toggler--search').trigger('click')
    },
    today: function () {
      var d = new Date()
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).toString().substring(1) + '-' + (('00' + d.getDate()).substring(1))
    },
    ricerca () {
      this.collapseMenuSearch()
      this.$store.dispatch('event/search', {
        q: this.search,
        start: this.start || this.today(),
        end: this.end + ' 23:59:59' || '9999-01-01'
      })
      this.search = ''
      this.start = this.end = null
    }
  }
}
</script>
